import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { ServiceCategoryEntity } from './service-category.entity'

export class ServiceCategoriesRepository extends BaseRepository<ServiceCategoryEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'service-categories', token, cache)
    }
}
